import Helpers from './helpers';

export default class PopUpOnLoad {
	constructor({ el }) {
		const { templateId } = el.dataset;
		PopUpOnLoad.renderPopUp(templateId);
	}

	static renderPopUp(templateId) {
		const cookieValue = templateId;
		if (!document.cookie.includes(cookieValue)) {
			window.addEventListener('load', () => {
				window.dispatchEvent(
					new CustomEvent('lightbox-show-by-template-id', {
						detail: {
							templateId,
						},
					})
				);
				return false;
			});
		}
		PopUpOnLoad.renderActions(templateId);
	}

	static renderActions(templateId) {
		document.querySelector('.lightbox__close').addEventListener('click', () => {
			Helpers.setCookie('dngPopUpLoad', templateId, 14);
		});
	}
}
